module.exports = __webpack_public_path__ + "img/mind_template_item_4_4.197b62e1.png";